const PREFIX = 'synergist-ai-context:';
const memory = new Map<string, string>();

const storage = () => {
    try {
        return window.sessionStorage;
    } catch {
        return null;
    }
};

export const rememberContextSummary = (contextKey: string, summary: string) => {
    const normalized = summary.trim();
    if (!contextKey || !normalized)
        return;
    memory.set(contextKey, normalized);
    storage()?.setItem(`${PREFIX}${contextKey}`, normalized);
};

export const recallContextSummary = (contextKey: string) => {
    if (!contextKey)
        return '';
    return memory.get(contextKey) ?? storage()?.getItem(`${PREFIX}${contextKey}`) ?? '';
};

export const clearContextSummary = (contextKey: string) => {
    memory.delete(contextKey);
    storage()?.removeItem(`${PREFIX}${contextKey}`);
};

